<template>
  <div class="sub-page">
    <div class="sub-header" style="background-image: url('/img/mine/login-bg.png'), linear-gradient(90deg, rgb(79, 43, 138), rgb(245, 96, 205));">
      <van-nav-bar :title="navTitle" class="sub-nav">
        <template #left>
          <van-icon name="arrow-left" color="#fff" @click="back()"/>
        </template>
      </van-nav-bar>
    </div>

    <div class="sub-body">
      <div class="card form-card">
        <div class="form-item">
          <label>*{{ inputLabel }}</label>
          <van-field
            v-model="usdt"
            :placeholder="inputPlaceholder"
            class="van-cell--borderless"
          />
        </div>

        <button type="button" class="submit-btn" @click="bindCard()"> 提交 </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      usdt: "",
      type: this.$route.query.type || 'TRC20'
    };
  },
  computed: {
    isErc() {
      return String(this.type).toUpperCase().includes('ERC');
    },
    navTitle() {
      return this.isErc ? 'USDT-ERC20' : 'USDT-TRC20';
    },
    inputLabel() {
      return this.isErc ? 'USDT-ERC20地址' : 'USDT-TRC20地址';
    },
    inputPlaceholder() {
      return this.isErc ? '請輸入USDT-ERC20地址' : '請輸入USDT-TRC20地址';
    }
  },
  methods: {
    back(){
      return window.history.back();
    },
    bindCard(){
      if(!this.usdt){
        this.$toast(this.inputPlaceholder);
        return false;
      }
      const postData = {
        type: this.isErc ? 'ERC20' : 'TRC20'
      };
      if (this.isErc) {
        postData.erc_usdt = this.usdt;
      } else {
        postData.usdt = this.usdt;
      }
      this.$http({
        method: 'post',
        data: postData,
        url: 'user_set_usdt'
      }).then(res => {
        if(res && res.code === 200){
          this.$toast.success(res.msg || '綁定成功');
          setTimeout(() => {
            this.$router.push('/Setbank');
          }, 500);
        } else if(res) {
          this.$toast(res.msg);
        }
      });
    },
    getUserBankInfo(){
      this.$http({
        method: 'get',
        url: 'user_get_bank'
      }).then(res => {
        if(res && res.code === 200 && res.data && res.data.info){
          if (this.isErc) {
            this.usdt = res.data.info.erc_usdt || "";
          } else {
            this.usdt = res.data.info.usdt || res.data.info.trc_usdt || "";
          }
        }
      });
    }
  },
  created() {
    this.type = this.$route.query.type || 'TRC20';
    if(!localStorage.getItem('token')){
      this.$router.push({path:'/Login'});
    } else {
      this.getUserBankInfo();
    }
  }
};
</script>

<style scoped>
.sub-page {
  width: 100%;
  min-height: 100vh;
  background-color: #f3f3f5;
  padding-bottom: 60px;
  box-sizing: border-box;
  font-family: -apple-system, BlinkMacSystemFont, "PingFang SC", "Helvetica Neue", STHeiti, "Microsoft Yahei", Tahoma, Simsun, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.sub-header {
  position: relative;
  width: 100%;
  height: 220px;
  background-image: url('/img/mine/login-bg.png'), linear-gradient(90deg, rgb(79, 43, 138), rgb(245, 96, 205));
  background-size: 100% auto;
  background-position: center bottom;
  background-repeat: no-repeat;
  box-sizing: border-box;
}

.sub-nav {
  background: transparent !important;
  height: 100px;
}

::v-deep .sub-nav .van-nav-bar__content {
  height: 100px;
}

::v-deep .sub-nav .van-nav-bar__title {
  color: #ffffff !important;
  font-size: 34px !important;
  font-weight: 600 !important;
  line-height: 100px;
}

::v-deep .sub-nav .van-icon {
  color: #ffffff !important;
  font-size: 44px !important;
}

.sub-body {
  padding: 0 30px;
  margin-top: -60px;
  position: relative;
  z-index: 10;
}

.form-card {
  background: #ffffff;
  border-radius: 24px;
  padding: 40px 30px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.05);
}

.form-item {
  margin-bottom: 24px;
}

.form-item label {
  display: block;
  font-size: 28px;
  color: #333333;
  margin-bottom: 12px;
  font-weight: 500;
}

.form-item .van-cell {
  background-color: #f7f7f9;
  border-radius: 16px;
  padding: 20px 24px;
  font-size: 28px;
}

.submit-btn {
  width: 100%;
  height: 90px;
  background: linear-gradient(90deg, #f560cd, #4f2b8a);
  color: #ffffff;
  border: none;
  border-radius: 45px;
  font-size: 32px;
  font-weight: 600;
  margin-top: 40px;
  cursor: pointer;
  box-shadow: 0 8px 20px rgba(79, 43, 138, 0.3);
}

.submit-btn:active {
  opacity: 0.9;
}
</style>
